module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', [_vm._v("His unspeakable brutality.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our bridal "), _c('a', {
    attrs: {
      "id": "p24"
    }
  }), _c('a', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("trip was to the New Jersey shore, which could be beautiful when the wind and tide cooperated. Otherwise, the detritus of New York City befouled the beaches. It was too cool for bathing, which I remember as a major physical disappointment—my nuptial duties, fulfilled frequently and with no patience, left me in a state that Edward laughingly called “saddle-sore.”")])]), _c('a', {
    attrs: {
      "id": "p25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I was immediately with child, but lost the little one, my only girl, in four months’ time. My third and fourth pregnancies also ended in miscarriages. It would be fifty years before medical science identified the Rh factor, but evidently that was our problem. Edward blamed it on some female weakness, and I was poked at and peered inside by specialists in New York and Boston as well as Philadelphia.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("My ")]), _c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("second baby was small, two months premature, but he survived. Daniel was a charming infant, naturally well-tempered, easily amused and amusing. After a slow start, he grew fast, and by two was big and strong for his age.")])]), _c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When it became clear that he had a son and heir, Edward stopped having sexual relations with me, at least of a kind that could result in pregnancy. What he did was painful and degrading, and I would think a sin, for its unnaturalness. But he said it was for my own sake, and there was nothing in the Bible about it, unless it were men done with men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He only came to me about once a month. He “worked late” often, though, and gossips told me he was often seen down by Drury Lane at night, an area full of prostitutes. In 1890 I found out that he had been supporting a mistress for years, keeping her on the firm’s books as an apprentice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I confronted him with this, he beat me so soundly that I lost a tooth. I should have left him then. He apologized, weeping, for his “nature,” and bought me a ruby necklace. We made up an excuse about a carriage accident, and a dentist crafted me a replacement tooth of porcelain.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("I looked ")]), _c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("back through my diaries and found that he had beaten me fifteen times in ten years, badly enough for me to record it. I went so far as to talk to my minister about it, although of course I left out the sexual details.")])]), _c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He was a kindly man, and offered to talk to Edward, but I thought that would certainly make things worse. He quoted scripture to me, which I already knew, about a woman’s place and obligations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was clear in my mind that the church and its ministers were fallible, and I still might have left him if it were just me. But Daniel loved him madly as a child, in spite of similar beatings, which at the time we thought were natural between father and son. Edward spent a lot of time with him when he was growing up, teaching him how to fish and sail and ride, and practicing sports with him. They laid out a small baseball diamond in the backyard, and installed a canvas pad in the basement, for boxing and wrestling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One Sunday in 1894, the servants out of the house, I heard a strange sound from the basement, a strained whimpering, and I opened the door slightly and peeked down. There on the boxing mat, my husband had pulled down their garments and was having his son the way he had me, like two dogs coupling. He had his hand over Daniels’ mouth, but couldn’t quite muzzle his agonized grunts.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("I ran ")]), _c('a', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("upstairs to where Edward kept his pistols, but there was no ammunition in sight, and I wasn’t really sure how to load and fire one. So I went to the kitchen and got a large cleaver.")])]), _c('a', {
    attrs: {
      "id": "p28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When I returned to the basement door, they were finished. Edward was buttoning up his clothing and spoke in harsh whispers to our son, cowering half naked on the mat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel saw me looking down, and at his expression I eased the door shut. I would find some more sure and safe way to deal with this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was in the kitchen making tea cookies when Edward came up. He said that Daniel had been slightly injured in their wrestling practice, and I was not to be worried if he had tears. After all, he was only fourteen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a large knife on the counter, and only God’s hand stayed me, saved me, from plunging it into his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He went upstairs to change, and then left for the club, his Sunday round of golf and cards. I waited for Daniel to come up, but he didn’t, and after some time I finally went down to the basement.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("He ")]), _c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("was sitting in the darkest corner, quiet, not crying. He asked whether he might launder his clothing alone. I said that he could, but I knew more about such things. I haltingly told him his father had used me the same way, and we cried together.")])]), _c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I washed the blood from his unmentionables and mixed an astringent poultice for him to apply. I told him to take a bath and then pack everything he could not live without into a small trunk. We were leaving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was so agitated my heart was leaping in my chest. Trying to sort out my thoughts—how to get away, where to go—I went out on the back porch, for some fresh air. I closed my eyes and tried to think clearly. Then opened them at the sound of clashing wings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There on the wooden steps was a black bird larger than any crow I had ever seen, a raven. He hopped up two steps and cocked his head at me. “No. Gold,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew they could be trained to talk. But why would he be taught those two words?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hopped closer. “No!” He squawked. “Gold!” In an explosion of feathers he flew past me, out into the backyard. He perched on the birdbath and repeated, “No gold!” Then he flew away.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("I was ")]), _c('a', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("completely unnerved by the experience. But then I wondered whether it might have been a sign. And the truth was immediately clear.")])]), _c('a', {
    attrs: {
      "id": "p30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I ran up to the bath and spoke to Daniel through the door. “Don’t rush, darling. We can’t leave until tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But Father won’t be home until late,” he said in a voice strained with fear. “We can run all day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told him no, I had thought it through, and that would be disastrous. We would be almost penniless unless I could get to the bank Monday morning, for my gold. And I had seven ladies coming for afternoon tea; if I weren’t here, they would suspect the worst, and there would be police looking for us high and low.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard him splashing and he came out dripping wet, a towel around his waist. “What gold?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s left over from my father’s bequest, over a hundred twenty-dollar gold pieces. I’ve never told your father about it.” I didn’t tell him about the bird’s warning. There was enough sudden strangeness in his world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded with a strangely adult, calculating look. “We could go anyplace with two thousand dollars.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("“We’ll leave ")]), _c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("right after he goes to the office tomorrow,” I said. “Take the first train to New York City. Then on to someplace where nobody will know us.”")])]), _c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I choose?” he asked, and I said of course, but think it over. It would have to be someplace that didn’t cost a fortune to get to, where I could get a job, where we wouldn’t stand out. Not the Belgian Congo or Antarctica. That made him gay. I told him which trunk to fill, and he went off to sort through his things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had to wait by the cookies; the woodstove was unpredictable, and I had to go by the smell of the baking. I started packing in my head, though. Books: only ones that couldn’t be replaced by mail order, because of long attachment. In poetry, Palgrave’s "), _c('em', [_vm._v("Golden Treasury")]), _vm._v(" and Shakespeare’s "), _c('em', [_vm._v("Sonnets.")]), _vm._v(" The "), _c('em', [_vm._v("Treasure Island")]), _vm._v(" and "), _c('em', [_vm._v("Huckleberry Finn")]), _vm._v(" I had read to Daniel. Perhaps I might have another child someday.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would need sturdy, plain clothes and one of my two velvet dresses, for church and interviews; a chemise for sleeping. A dark Gibson Girl outfit for classroom or office, wherever I’d be working, perhaps two of them. I thought with longing of the huge Saratoga, that held all the clothes I could need for weeks in Boston or New York. But I wanted no more than a porter could easily carry; small enough for me to handle alone, if need be.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("My ")]), _c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("drawing equipment and watercolors, leaving behind the oils and their so-called portable easel. My diaries and two or three sketchbooks, the most recent. I hated to leave the others behind; it literally was leaving a part of my self behind. But they were too bulky.")])]), _c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I would fill new ones. The prospect of having a new world to draw and paint gave me a sudden lift in spirits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If I had known how literally true that would be!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel came down carrying the atlas. He opened it to Kansas and pointed to Dodge City.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, why not? It was the ends of the earth, but that was what I wanted. If I couldn’t get a job there—teaching or rounding up cattle, or whatever single women did there who didn’t want to be “soiled doves”—we could move to Kansas City or St. Louis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I warned him not to be too disappointed if there weren’t a lot of gunfights and cowboys. He said sure; he knew that was all dime novel stuff, but his eyes glittered with excitement. I hoped he wouldn’t be too let down by the reality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He filled the large teakettle with water and hoisted it up on the stove while I took out the cookies and arranged them on plates to cool. Ginger, vanilla, and chocolate smells, mingling for the last time. I wrapped a few warm ones for Daniel, and sent him out to the library while I entertained the church ladies.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("He ")]), _c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("asked whether he could check out books, or would that be stealing?—trying to pull an innocent face that made us both laugh. I told him I wasn’t ready to begin a life of crime.")])]), _c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As I watched him scamper out, though, I realized that it might be just that. Taking the son of a wealthy Philadelphia lawyer might be kidnapping, even if you were the son’s mother. But I put that out of my mind. Edward would never have us pursued, knowing what we could tell the authorities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had political ambitions. The charge of incestual sodomy might cost him some votes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In retrospect I see how dangerously I underestimated his capacity for what I then would have called evil—for what his black anger might drive him to, finding that I had stolen the one possession he could never replace. Dodge City might have been the ends of the earth, but it wouldn’t be far enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Putting the tea things together, I had to wonder how much of this I would be giving up. I wouldn’t miss the society of the proper, stuffy church ladies. But I always looked forward to the two who were chatty and fun, Eleanor and Roxanne. Would there be enough women, proper women, in Dodge City to put together tea parties like this? Would there even be tea?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("I could ")]), _c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("afford to take a tin of my favorite, the Fortnum & Mason from London. I looked longingly at the two tea services, but no. No room for indulgence. I would get us a sturdy teapot and two cups in the New York station, waiting for the train west.")])]), _c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The tea party was excruciatingly long and slow. I had to feign interest in church politics and minor scandal while my mind was spinning with the horror of what I’d seen in the basement and the giddy hope of escape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel came in when the last of them left; he’d been waiting in the park across the street. At the library he’d found a book on Kansas and had written out three pages from it. I read it while he had some cool sweet tea and cleaned up the cookie fragments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then we went upstairs and each packed and repacked our small trunks. They were awkward to handle, but Daniel improvised a lashing from two strips of leather he’d found down in the stable, so we could lift them together, each of us taking one side. I allowed him to bring his precious guitar. In fact, he looked jaunty and handsome in his traveling clothes, guitar slung around his back.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("I ")]), _c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("wished we could just walk out the door and leave. But the key to our freedom resided in a safe-deposit box I couldn’t open on Sunday.")])]), _c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So I assembled a pot roast to cook slowly and straightened up the parlor and kitchen, which usually I would have left for the maid, even though Edward might grumble about the mess. I wanted to treat him with the utmost solicitude, so he would leave in the morning content and unsuspecting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He came home late, flushed with drink and dangerously quiet. I had already given Daniel his supper and sent him to bed, to get a good night’s sleep for “school” tomorrow. Edward toyed with his food and drank most of a bottle of wine, and then wordlessly tramped upstairs, and into Daniel’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afraid of what he might do with the boy, I followed silently a minute later and listened at the door. They were only talking quietly. I hid in the laundry closet across the hall, ready to use a flatiron on him if need be. But he emerged twenty minutes later and went down to the parlor. I heard glass clinking and smelled his cigar, so I cracked Daniel’s door a bit and asked if he were well. He said he was all right and I bade him good night; good morrow. He repeated “good morrow” so brightly I knew he wouldn’t sleep much.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("If ")]), _c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("he had told me then what he was to tell me on the train the next day, I might have gone downstairs and cracked Edward’s precious brandy decanter across his skull. He had made the child pray for forgiveness, for having tempted his father into sin, and promise that he would put away all sinful thoughts and not mention this to anyone, or burn in hell.")])]), _c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The boy did take that for what it was worth, nothing, but it renewed my fury at Edward. That abuse of a father’s authority could only undermine an impressionable child’s trust in God’s authority as well. In later years I was to fight a hard battle, not wholly won, against Daniel’s constant doubting and attraction to atheism, and I hope his father’s soul is heavily burdened with his responsibility for that, on top of everything else.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2332c4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter003.vue
// module id = 84
// module chunks = 0